import $ from 'jquery';
import axios from "axios";
import { initProductTileItem } from './basket';

$(function() {

    initOfferDetail();

    initOfferProducts();

});


function initOfferDetail() {

    $(document).on('click', '.show-offer-detail', function() {
        let offerId = $(this).attr('data-offer-id');
        showOfferDetail(offerId);
    });

}


function showOfferDetail(offerId) {

    return axios.post('/offer/details', {
        offerId: offerId
    }).then(function (response) {
        if (response.data) {
            $('.wrapper-offers .inner').html(response.data);
            $('.wrapper-offers').css({'top': '0'});
            $('.wrapper-offers-mask').delay(350).fadeIn(150);
            initProductTileItem();
            initCloseOfferDetail();
        }
    })
        .catch(function (error) {
            console.log(error);
        });

}


window.initOfferDetail = function() {
    initOfferDetail();
};


function initCloseOfferDetail() {

    $(document).on('click', '.close-offer-detail', function() {
        $('.wrapper-offers-mask').hide();
        $('.wrapper-offers').css({'top': '100%'});
        $('.wrapper-offers .inner').html('');
    });

}


function initOfferProducts() {

    $(document).on('click', '.select-offer-products', function() {
        let offerId = $(this).attr('data-offer-id');
        let qualifyCount = $(this).attr('data-offer-qualify-count');
        showOfferProductsSelect(offerId, qualifyCount);
    });

}


function showOfferProductsSelect(offerId, qualifyCount) {

    return axios.post('/offer/products', {
        offerId: offerId,
        qualifyCount: qualifyCount
    }).then(function (response) {
        if (response.data) {
            $('.wrapper-offers .inner').html(response.data);
            $('.wrapper-offers').css({'top': '0'});
            $('.wrapper-offers-mask').delay(350).fadeIn(150);
            initCloseOfferDetail();
        }
    })
        .catch(function (error) {
            console.log(error);
        });

}



